import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { actions } from '../../ShedManagementState'
import { useDispatch } from 'react-redux'
import FormUpdateAttributesLocations from '../../components/FormUpdateAttributesLocations/FormUpdateAttributesLocations'
import FormSearchLocation from '../../components/FormSearchLocation/FormSearchLocation'
import * as S from './ShedManagementLocations.styles'

const ShedManagementLocations = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.getAttributesGroup)
  }, [dispatch])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>Gestão de atributos de localizações</Typography>
      <FormSearchLocation />
      <FormUpdateAttributesLocations />
    </S.Wrapper>
  )
}

export default ShedManagementLocations
